module.exports = __webpack_public_path__ + "img/MX-C050055A-BE-HQ.913eeecc.png";